const config: Readonly<any> = {
  dataset_sample_size: 3,
  default_project: 'common',
  session_inactive_timeout: 60, // minutes
  session_inactive_warning: 1, // minutes
};

export default Object.freeze(config);
